import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "For playback, the signal altering properties of the playback device (e.g. headphone or loudspeaker) have to be accounted for. The reduction of differences in level and in the transfer properties between different devices or even individual channels is particularly relevant for the reproduction of binaural signals (see lesson 3.19 for details).",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/02/16/principle/slide-4.svg`,
            },
          },
          styles: {
            padding: "2%",
          },
        },
      },
    },
  },
};

export default principle;
